<template>
  <div class="vx-row">
    <div class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-0 mt-base">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/1 lg:mt-0 md:mt-0 mt-base">
          <vs-table stripe max-items="10" pagination :data="stats">
            <template slot="header">
              <h3 class="mb-6">{{ productTitle || tagSource.charAt(0).toUpperCase() + tagSource.slice(1) }} Tap Stats</h3>
              <vs-dropdown v-if="showProductSelection" vs-trigger-click class="cursor-pointer ml-4 mb-6" style="min-width:200px">
                <div class="p-4 shadow border border-solid d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                  <span class="mr-2">{{ actionDropdownTitle }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu class="search-page__more-dropdown">
                  <vs-dropdown-item
                    v-for="item in productOptions"
                    :key="item.title"
                    @click="changeProduct(item)"
                    >
                    {{ item.title }}
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </template>
            <template slot="thead">
              <vs-th sort-key="action">
                Action
              </vs-th>
              <vs-th sort-key="created">
                Date & Time
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="data[indextr].action">
                  {{data[indextr].action}}
                </vs-td>

                <vs-td :data="data[indextr].created">
                  {{data[indextr].created}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data:() => ({
    tagSource: '',
    stats: [],
    productTitle: '',
    actionDropdownTitle: '',
    showProductSelection: false,
    productOptions: []
  }),
  computed: mapState(['AppActiveUser']),
  created () {
    this.tagSource = this.$route.params.tagSource
    if (this.AppActiveUser.uid === 0) {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'UPDATE_USER_INFO') {
          if (state.AppActiveUser !== 0) {
            this.getStats()
            this.getUserProducts()
            this.getProductTitle()
          }
        }
      })
    } else {
      this.getStats()
      this.getUserProducts()
      this.getProductTitle()
    }
  },
  beforeDestroy () {
    const unsubscribe = this.$store.subscribe(() => {})
    unsubscribe()
  },
  watch:{
    $route (to) {
      if (to.params.tagSource !== this.tagSource) {
        this.tagSource = to.params.tagSource
        this.getStats()
      }
    }
  },
  methods: {
    getUserProducts () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').get()
        .then(actionsData => {
          if (actionsData.docs.length > 2) {
            this.showProductSelection = true
            this.actionDropdownTitle = actionsData.docs[0].data().title
            actionsData.docs.forEach(doc => {
              if (doc.data().title !== undefined) {
                this.productOptions.push({
                  id: doc.id,
                  title: doc.data().title
                })
              }
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeProduct (item) {
      this.$router.push({ path: `/stats/${item.id}` })
    },
    getProductTitle () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').doc(this.tagSource).get()
        .then(docData => {
          this.productTitle = docData.data().title
        })
    },
    getStats () {
      this.stats = []
      this.$fs.collection('client').doc(this.AppActiveUser.uid).collection('actions').doc(this.tagSource).collection('stats')
        .orderBy('created', 'desc').get()
        .then(docsData => {
          docsData.docs.forEach(doc => {
            let actionType = ''

            switch (doc.data().action.action) {
            case 'profile':
              actionType = 'Opened your profile'
              break
            case 'redirectSocial':
              actionType = `Redirected to your ${doc.data().action.provider} social profile (${doc.data().action.value})`
              break
            case 'redirectWebsite':
              actionType = `Redirected to your website ${doc.data().action.value}`
              break
            case 'contactCard':
              actionType = 'Saved your contact card'
              break
            }

            this.stats.push({
              action: actionType,
              created: doc.data().created.toDate()
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>